var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMessages = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,4c-1.2-1.6-2.8-2.7-4.6-3.4c-0.9-0.3-1.9-0.5-2.8-0.6h-0.3c-0.9,0-1.8,0-2.6,0.3c-1.9,0.5-3.6,1.5-5,2.9 S0.5,6.3,0.1,8.3C-0.2,10.2,0,12.2,0.8,14c0.8,1.8,2.1,3.3,3.7,4.4C6.1,19.4,8.1,20,10,20h5.8c1.1,0,2.2-0.4,2.9-1.2 c0.8-0.8,1.2-1.8,1.2-2.9V9.4C19.9,7.4,19.2,5.6,18,4z M18.3,15.8c0,0.7-0.3,1.3-0.7,1.8c-0.5,0.5-1.1,0.7-1.8,0.7H10 c-1.2,0-2.3-0.2-3.4-0.7c-1.1-0.5-2-1.2-2.8-2.1c-0.8-0.9-1.4-1.9-1.7-3C1.7,11.4,1.6,10.2,1.7,9c0.2-1.8,1.1-3.6,2.4-4.9 c1.3-1.3,3-2.2,4.9-2.4c0.4,0,0.7-0.1,1.1-0.1c1.9,0,3.8,0.7,5.3,1.9c0.9,0.7,1.6,1.6,2.1,2.6s0.8,2.1,0.9,3.2V15.8z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.7,7.5H10c0.2,0,0.4-0.1,0.6-0.2c0.2-0.2,0.2-0.4,0.2-0.6s-0.1-0.4-0.2-0.6c-0.2-0.2-0.4-0.2-0.6-0.2H6.7 c-0.2,0-0.4,0.1-0.6,0.2C5.9,6.2,5.8,6.5,5.8,6.7s0.1,0.4,0.2,0.6C6.2,7.4,6.4,7.5,6.7,7.5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,9.2H6.7c-0.2,0-0.4,0.1-0.6,0.2C5.9,9.6,5.8,9.8,5.8,10c0,0.2,0.1,0.4,0.2,0.6c0.2,0.2,0.4,0.2,0.6,0.2 h6.7c0.2,0,0.4-0.1,0.6-0.2c0.2-0.2,0.2-0.4,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6C13.8,9.3,13.6,9.2,13.3,9.2z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,12.5H6.7c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.2-0.2,0.4-0.2,0.6c0,0.2,0.1,0.4,0.2,0.6 c0.2,0.2,0.4,0.2,0.6,0.2h6.7c0.2,0,0.4-0.1,0.6-0.2c0.2-0.2,0.2-0.4,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6C13.8,12.6,13.6,12.5,13.3,12.5 z",
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMessages, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/messages.c4726dee.svg";
export { ForwardRef as ReactComponent };